//      
import React from 'react';
import styled from 'styled-components';

import dates from 'utils/dates';

const DateWrapper = styled.span`
    &:hover {
        cursor: cell;
    }
`;

                     
                                 
                       
                    
  

export const FormattedTimeFromNow = ({
    date,
    helpFormat,
    suffix,
    ...spanProps
}       ) => {
    return (
        <DateWrapper
            className='date-component'
            title={dates.formatDate(date, helpFormat)}
            {...spanProps}
        >
            {dates.formatRelativeDate(date, suffix)}
        </DateWrapper>
    );
};

FormattedTimeFromNow.defaultProps = {
    helpFormat: 'LLLL',
    suffix: true,
};

export default FormattedTimeFromNow;
